import React, { FC } from 'react';
import { Button } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import { YesNoFieldModel } from '../../../../models/form/fields/yesNo';

export interface Props {
  value: YesNoFieldModel['defaultValue'];
  enabled: boolean;
  allowNa: boolean;
  onChange: (val: string | undefined) => void;
  readOnlyMode?: boolean;
}

const outlineNormal = 'outline-primary';
const YesNoNa: FC<Props> = ({ value, enabled, allowNa, onChange, readOnlyMode }: Props) => {
  async function setValue(val) {
    if (value === val) {
      await onChange(undefined);
    } else {
      await onChange(val);
    }
  }
  return (
    <div className="yesNoNa-field">
      <Button
        id="yes"
        variant={value === 'yes' ? 'success' : outlineNormal}
        onClick={async () => setValue('yes')}
        disabled={!enabled || readOnlyMode}
        className="me-1"
      >
        <FormattedMessage id="public.controls.yesNo.yes"></FormattedMessage>
      </Button>
      <Button
        id="no"
        variant={value === 'no' ? 'danger' : outlineNormal}
        onClick={async () => setValue('no')}
        className="mx-1"
        disabled={!enabled || readOnlyMode}
      >
        <FormattedMessage id="public.controls.yesNo.no"></FormattedMessage>
      </Button>
      {allowNa && (
        <Button
          id="na"
          variant={value === 'na' ? 'info' : outlineNormal}
          onClick={async () => setValue('na')}
          className="ms-1"
          disabled={!enabled || readOnlyMode}
        >
          <FormattedMessage id="public.controls.yesNo.na"></FormattedMessage>
        </Button>
      )}
    </div>
  );
};

export default YesNoNa;
